/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

import { useTranslation } from 'gatsby-plugin-react-i18next';

const Seo = ({
  meta, schema,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `,
  );

  const { t } = useTranslation();

  const siteUrl = site.siteMetadata?.siteUrl;
  const siteLang = t('htmlLang');
  const ogImage = `${siteUrl}/images/ukraine.png`;
  const schemaAttrs = schema ? { itemscope: undefined, itemtype: `http://schema.org/${schema}` } : null;

  return (
    <Helmet
      htmlAttributes={{
        lang: siteLang,
        ...schemaAttrs,
      }}
      meta={[
        {
          property: `og:url`,
          content: siteUrl,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:title`,
          content: t('pages.home.title'),
        },
        {
          property: `og:description`,
          content: t('pages.home.metaDescription'),
        },
        {
          property: `og:image`,
          content: ogImage,
        },
      ].concat(meta)}
    />
  );
};

Seo.defaultProps = {
  meta: [],
};

Seo.propTypes = {
  meta: PropTypes.arrayOf(PropTypes.shape),
  schema: PropTypes.string,
};

export default Seo;
